module.exports = __webpack_public_path__ + "static/img/RGH-Security-Printing.2d0a7f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/Sectors/RGH-Security-Printing.jpg
// module id = 9fsU
// module chunks = 1